export default __webpack_public_path__ + "static/media/man-user.e46b4847.svg";